export const infoData = {
    monthlyIncome: `Your monthly taxable income is the money you earn each month from your job or other sources before tax or any deductions. It's your total earnings in a given month. `,
};